import { render, staticRenderFns } from "./Video.vue?vue&type=template&id=52aff108&"
import script from "./Video.vue?vue&type=script&lang=js&"
export * from "./Video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52aff108')) {
      api.createRecord('52aff108', component.options)
    } else {
      api.reload('52aff108', component.options)
    }
    module.hot.accept("./Video.vue?vue&type=template&id=52aff108&", function () {
      api.rerender('52aff108', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/conversation/bubble/Video.vue"
export default component.exports